const dummyProducts = [
  {
    id: '1',
    name: 'Mutton',
    nameBn: 'গরুর মাংস',
    category: 'Meat',
    currentStock: 12.5,
    unit: 'kg',
    minStockLevel: 5,
    pricePerUnit: 600,
    supplier: 'Fresh Meat Suppliers Ltd.',
    lastRestock: '2025-6-15T09:30:00',
    expiryDate: '2025-6-22',
    description: 'Premium quality mutton from local farms',
    storageLocation: 'Freezer A1',
    barcode: '8901234567890',
    movementHistory: [
      {
        date: '2025-6-15', type: 'in', quantity: 15, user: 'Store Manager',
      },
      {
        date: '2025-6-18', type: 'out', quantity: 2.5, user: 'Head Chef',
      },
    ],
  },
  {
    id: '2',
    name: 'Mustard Oil',
    nameBn: 'সরিষার তেল',
    category: 'Oil',
    currentStock: 8,
    unit: 'liters',
    minStockLevel: 3,
    pricePerUnit: 80,
    supplier: 'Pure Oil Distributors',
    lastRestock: '2025-6-10T14:15:00',
    expiryDate: '2024-05-10',
    description: 'Cold-pressed mustard oil',
    storageLocation: 'Dry Store B2',
    barcode: '8901234567891',
    movementHistory: [
      {
        date: '2025-6-10', type: 'in', quantity: 10, user: 'Inventory Staff',
      },
      {
        date: '2025-6-12', type: 'out', quantity: 2, user: 'Sous Chef',
      },
    ],
  },
  {
    id: '3',
    name: 'Tomato',
    nameBn: 'টমেটো',
    category: 'Vegetables',
    currentStock: 25,
    unit: 'kg',
    minStockLevel: 10,
    pricePerUnit: 100,
    supplier: 'Local Vegetable Suppliers',
    lastRestock: '2025-6-12T10:00:00',
    expiryDate: '2025-6-19',
    description: 'Fresh organic tomatoes',
    storageLocation: 'Chiller C1',
    barcode: '8901234567892',
    movementHistory: [
      {
        date: '2025-6-12', type: 'in', quantity: 30, user: 'Store Manager',
      },
      {
        date: '2025-6-15', type: 'out', quantity: 5, user: 'Head Chef',
      },
    ],
  },
  {
    id: '4',
    name: 'জিরা',
    nameBn: 'জিরা',
    category: 'Spices',
    currentStock: 5,
    unit: 'kg',
    minStockLevel: 2,
    pricePerUnit: 300,
    supplier: 'Spice World',
    lastRestock: '2025-6-10T14:15:00',
    expiryDate: '2025-6-30',
    description: 'Premium quality cumin seeds',
    storageLocation: 'Spice Rack D1',
    barcode: '8901234567893',
    movementHistory: [
      {
        date: '2025-6-10', type: 'in', quantity: 10, user: 'Inventory Staff',
      },
      {
        date: '2025-6-12', type: 'out', quantity: 5, user: 'Sous Chef',
      },
    ],
  },
  {
    id: '5',
    name: 'Apple',
    nameBn: 'আপেল',
    category: 'Fruit',
    currentStock: 50,
    unit: 'kg',
    minStockLevel: 20,
    pricePerUnit: 150,
    supplier: 'Fresh Fruit Suppliers',
    lastRestock: '2025-6-05T09:30:00',
    expiryDate: '2025-6-20',
    description: 'Crisp and juicy apples',
    storageLocation: 'Chiller C2',
    barcode: '8901234567894',
    movementHistory: [
      {
        date: '2025-6-05', type: 'in', quantity: 60, user: 'Store Manager',
      },
      {
        date: '2025-6-10', type: 'out', quantity: 10, user: 'Head Chef',
      },
    ],
  },
];

export default dummyProducts;
